import React from 'react';
import { cn } from '../../../lib/utils';

export interface TaskyPageHeaderProps
  extends Omit<React.HTMLAttributes<HTMLElement>, 'title'> {
  title: React.ReactNode;
  description?: React.ReactNode;
  breadcrumb?: React.ReactNode;
  actions?: React.ReactNode;
  /** タイトル行の下に出す 2 段目（フィルタ・期間・切替）。未指定なら DOM を増やさない。 */
  toolbar?: React.ReactNode;
  sticky?: boolean;
}

export const TaskyPageHeader: React.FC<TaskyPageHeaderProps> = ({
  className,
  title,
  description,
  breadcrumb,
  actions,
  toolbar,
  sticky,
  ...rest
}) => (
  <header
    {...rest}
    className={cn(
      'bg-white border-b border-warm-border px-6 py-4',
      sticky && 'sticky top-0 z-20',
      className,
    )}
  >
    {breadcrumb && <div className="text-xs text-gray-500 mb-1">{breadcrumb}</div>}
    <div className="flex items-start justify-between gap-4">
      <div className="min-w-0">
        <h1 className="text-xl font-bold text-dark truncate">{title}</h1>
        {description && <p className="text-sm text-gray-500 mt-1">{description}</p>}
      </div>
      {actions && <div className="flex items-center gap-2 shrink-0">{actions}</div>}
    </div>
    {toolbar && (
      // 中身（SegmentedControl / select など）で高さが変わるとタブ行の位置が画面ごとにずれるため、
      // 最小高さを固定する。折り返して 2 行になったときは自然に伸びる。
      <div className="mt-3 flex min-h-[48px] flex-wrap items-center gap-2">{toolbar}</div>
    )}
  </header>
);
